import React, { useEffect, useRef } from 'react';
import Hls from 'hls.js';

const StreamPlayer = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;

    if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource("https://Stream-backend.arth.team/stream/playlist.m3u8");
      hls.attachMedia(video);

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        video.muted = true; // Required for autoplay
        video.play().catch((err) => {
          console.warn('Autoplay failed:', err);
        });
      });

      return () => hls.destroy();
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
      // Safari fallback
      video.src = "https://Stream-backend.arth.team/stream/playlist.m3u8";
      video.addEventListener('loadedmetadata', () => {
        video.muted = true;
        video.play().catch(console.warn);
      });
    }
  }, []);

  return (
    <video
      ref={videoRef}
      controls
      autoPlay
      muted
      playsInline
      style={{ width: "100%", height:"100%", backgroundColor: "black" }}
    />
  );
};

export default StreamPlayer;
